import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { IEmailTemplate } from '../../../models/email-template.model';
import { EmailTemplatesService } from '../../../services/email-templates.service';
import { SidenavService } from '../../../services/sidenav.service';

@Component({
  selector: 'app-email-templates-list',
  templateUrl: './email-templates-list.component.html',
  styleUrls: ['./email-templates-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmailTemplatesListComponent implements OnInit {
  @BlockUI() blockUI!: NgBlockUI;

  sidenav: MatSidenav;
  loading = false;
  templates: IEmailTemplate[] = [];
  filteredTemplates: IEmailTemplate[] = [];
  categories: string[] = [];
  searchTerm = '';
  selectedCategory = '';

  constructor(
    private sidenavService: SidenavService,
    private emailTemplatesService: EmailTemplatesService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
  }

  async ngOnInit(): Promise<void> {
    await this.loadTemplates();
  }

  toggleMenu(): void {
    this.sidenavService.toggle();
  }

  goBack(): void {
    this.router.navigate(['/admin']);
  }

  editTemplate(key: string): void {
    this.router.navigate(['/admin/email-templates', key]);
  }

  applyFilter(): void {
    let result = [...this.templates];

    if (this.searchTerm.trim()) {
      const term = this.searchTerm.toLowerCase();
      result = result.filter(
        (t) =>
          t.name.toLowerCase().includes(term) ||
          t.key.toLowerCase().includes(term) ||
          (t.description || '').toLowerCase().includes(term),
      );
    }

    if (this.selectedCategory) {
      result = result.filter((t) => t.category === this.selectedCategory);
    }

    this.filteredTemplates = result;
    this.cdr.markForCheck();
  }

  private async loadTemplates(): Promise<void> {
    this.loading = true;
    this.blockUI.start();
    try {
      this.templates = await this.emailTemplatesService.getList();
      this.categories = [
        ...new Set(this.templates.map((t) => t.category)),
      ].sort();
      this.filteredTemplates = [...this.templates];
    } finally {
      this.loading = false;
      this.blockUI.stop();
      this.cdr.markForCheck();
    }
  }
}
